import { useCollectiveDemoContext } from 'context/CollectiveDemoContext'
import { CollectiveProposalStatus } from 'graphql/generated'
import { useCallback } from 'react'

export const useSucceedProposal = () => {
  const { collectiveDemo, getProposalForId, updateDemoCache } =
    useCollectiveDemoContext()

  const succeedProposal = useCallback(
    id => {
      if (!collectiveDemo) {
        return
      }

      const newCollectiveDemo = { ...collectiveDemo }

      const proposalFound = newCollectiveDemo.proposals.edges.find(
        proposal => proposal.node.id === id
      )
      if (!proposalFound) {
        return
      }

      proposalFound.node.status = CollectiveProposalStatus.SUCCEEDED

      const proposal = getProposalForId(id)
      if (proposal) {
        proposal.status = CollectiveProposalStatus.SUCCEEDED
      }

      updateDemoCache(newCollectiveDemo)
    },
    [collectiveDemo, getProposalForId, updateDemoCache]
  )

  return succeedProposal
}
